interface Props {
  n: number;
  children: React.ReactNode;
  /** Optional muted second line shown below the heading (e.g. a hint). */
  subtitle?: React.ReactNode;
}

/**
 * Section heading with a gold numbered circle (① Choose a style).
 *
 * Font size + weight are set inline (24px / 700) rather than via Tailwind
 * utility classes so they survive any CSS purge/cache mismatch and Dawn's
 * own heading rules — the headings must always render at the woo size.
 *
 * When `subtitle` is given, the title + subtitle stack in a column and the
 * number circle aligns to the top so it doesn't look off-centre.
 */
export function NumberedHeading({ n, children, subtitle }: Props) {
  return (
    <h3
      className="flex gap-3 mt-0 mb-6 text-warm-brown"
      style={{
        alignItems: subtitle ? 'flex-start' : 'center',
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: '-0.01em',
      }}
    >
      <span
        className="inline-grid place-items-center rounded-full bg-teal text-white flex-shrink-0"
        style={{
          width: '28px',
          height: '28px',
          fontSize: '14px',
          fontWeight: 700,
          marginTop: subtitle ? '2px' : 0,
        }}
      >
        {n}
      </span>
      {subtitle ? (
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <span>{children}</span>
          <span
            style={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#757575',
              marginTop: '6px',
              textTransform: 'none',
              letterSpacing: 'normal',
              lineHeight: 1.4,
            }}
          >
            {subtitle}
          </span>
        </span>
      ) : (
        children
      )}
    </h3>
  );
}
